import React from "react";
import styles from "./input.module.scss";

const Index = ({
  placeholder = "Phone",
  onFocus = () => {},
  onChange = () => {},
  value = "",
  type = "",
  country = "IN",
  maxlength="",
  hasError=false
}) => {
  const countryData = countries?.filter((el) => el?.country == country)?.[0];
  

  return type == "phoneNumber" ? (
    <div className={styles["wrapper"]}>
      <img
        className={styles["prefix"]}
        src={countryData?.flag}
        alt={countryData?.country}
      />
      <span className={styles["dial-code"]}>{countryData?.dialCode}</span>
      <input
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        maxlength={maxlength}
        type={type}
        className={hasError && styles.errorInput}
      ></input>
      {false && (
        <div className={styles["drop-down"]}>
          {countries?.map((item, i) => (
            <div key={i}>
              <img src={item?.flag} />
            </div>
          ))}
        </div>
      )}
    </div>
  ) : (
    <div className={styles["wrapper"]}>
      <input
        onChange={onChange}
        required
        style={{ paddingLeft: "16px" }}
        value={value}
        maxlength={maxlength}
        type={type}
        className={hasError && styles.errorInput}
      ></input>
      <span className={styles["floating-label"]}>{placeholder}</span>
    </div>
  );
};

export default Index;

export const countries = [
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
  {
    country: "IN",
    flag: "https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/flags/IN.svg",
    dialCode: "+91",
  },
  {
    country: "NP",
    flag: "https://d34kmefuuy0be0.cloudfront.net/ev_assets/flag_NP_b2b06f5437.svg",
    dialCode: "+977",
  },
];
